<template>
    <v-card
        style="background: white; font-family: Montserrat; border: 1px solid gray; border-radius: 10px !important;"
        class="elevation-0 mt-8"
        :height="cardheight"
        width="344"
        rounded="10"
    >
        <v-img :src="lga_img" max-width="90px" max-height="67px" class="mx-auto mt-8" style="border-radius: 0px !important;"></v-img>
        <v-card-text style="margin-top: -20px;">
            <v-row class="mt-3 ml-1 amount">
                <v-col cols="12">
                    <span style="color: #46C3B2; font-size: large;"><sup>$</sup></span>
                    <span class="premium">{{primaryPremium}} </span>
                    <span class="main-frequency">monthly<sup><span style="color:#46C3B2">*</span></sup></span>
                </v-col>
            </v-row>
            <v-card-actions
                @click="show = !show"
            >
                <v-btn
                color="q-secondary lighten-2"
                text
                class="text-subtitle-2"
                >
                    <span style="text-align: left; font: normal normal bold 17px/35px Montserrat; letter-spacing: 0px; color: #005952; opacity: 1;">
                        Banner Product Benefits
                    </span>
                </v-btn>

                <v-btn
                color="q-secondary lighten-2"
                icon
                >
                <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </v-btn>
            </v-card-actions>

            <v-expand-transition>
                <div v-show="show">
                <v-card-text>
                    <v-list flat>
                        <v-list-item
                            class="mt-n5"
                            v-for="(msg, i) in lga_card_info.messages"
                            :key="i"
                        >
                            <v-list-item-icon class="mr-0">
                                <v-icon color="q-primary">mdi-circle-small</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title class="text-caption text-wrap" style="color: #005851; font-family: Montserrat !important" v-html="msg"></v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-card-text>
                </div>
            </v-expand-transition>
            <v-btn
                color="q-secondary"
                depressed
                class="get-started px-3"
                block
                @click="launchEapp"
                :disabled="fetchingQuote"
                style="margin-top: 75px;"
            >
                Continue
            </v-btn>
        </v-card-text>
    </v-card>
</template>

<script>
import quilityMixin from "@/mixins/quilityMixin";

export default {
    name: "LGAQuoteCard",
    mixins: [quilityMixin],
    data: () => ({
        lga_img: null,
        show: false
    }),
    computed: {
        lgaData(){
            return this.quoteData.quotes.find(q => q.Carrier === "LGA" || q.Carrier === "Banner" || q.Carrier === "Banner Life")
        },
        monthlyPremium(){
            return this.formatNumber(2,2, this.lgaData.Premium)
        },
        cardheight() {
            return this.show ? '480' : '323'
        },
        dailyPremium(){
            return this.formatNumber(2,2, (this.lgaData.Premium / 30))
        },
        primaryPremium(){
            return this.formatNumber(2,2, this.lgaData.Premium)
        },
        secondaryPremium(){
            return this.freq_treatment ? this.monthlyPremium : this.dailyPremium
        },
    },
    mounted(){
        this.lga_img = this.getImgUrl(this.lga_card_info.logo)
        this.show = !this.isMobile
    },
    methods: {
        async launchEapp(){
            // OC-1404: Check if agent is licensed in customer's state
            if (this.isOCSite) {
                const agentLicensed = this.agent.agentLicenses && this.agent.agentLicenses.includes(this.form.state_id);
                
                if (!agentLicensed) {
                    // Agent not licensed - redirect to thank you page
                    this.$router.push({ name: 'HatchThankyou' });
                    return;
                }
            }

            try {
                await this.gotoEapp() // redirect to the e-app
            } catch (error) {
                console.error(error)
            }
        },
        async gotoEapp() {
            const postParam = {
                "AgentCode": this.agent.agentCode,
                "AgentFirstName": this.agent.agentFirstName,
                "AgentLastName": this.agent.agentLastName,
                "FirstName": this.form.first_name,
                "LastName": this.form.last_name,
                "DOB": this.form.dob_formatted,
                "Phone": this.form.phone_number,
                "State": this.form.state_id,
                "Zipcode": this.form.zip_code,
                "FaceAmount": `${this.form.coverage_amount}`,
                "TermLength": this.form.coverage_plan.substring(0, 2),
                "QuoteRequestId": this.lgaData.QuoteRespone.quoteRequestId,
                "QuoteRequestResultId": this.lgaData.QuoteRespone.quoteRequestResultId,
                "IsOCInstance": this.isOCSite,
                "Email": this.form.email,
            }

            let ste_url = process.env.VUE_APP_PROXY + 'apply-lga';

            try {
                this.$store.commit('updateEnteringEApp', true)
                this.$store.commit('updateSelectedProduct', 'LGA')
                this.eApp_dialog = true

                let res = await fetch(ste_url,{
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify(postParam),
                })
                let json_data = await res.json()

                // kill split instance
                if(json_data.success){
                    // OC-1509: Store case tracking BEFORE redirecting
                    // Get External Partner ID from Vuex store (set in RAQForm)
                    const externalPartnerId = this.$store.state.externalPartnerId;
                    const isOCSite = this.isOCSite;
                    const agentCode = this.agent.agentCode;
                    const caseId = json_data.caseId;
                    
                    if (isOCSite && externalPartnerId && caseId && agentCode) {
                        try {
                            await this.storeHatchCaseTracking(caseId, externalPartnerId, agentCode)
                        } catch (error) {
                            console.error('Error storing case tracking', error)
                            // Continue to redirect even if tracking fails
                        }
                    } else {
                        console.error('Missing values for storing case tracking', JSON.stringify({
                            isOCSite,
                            externalPartnerId,
                            agentCode,
                            caseId,
                            json_data
                        }));
                    }

                    await this.$split_client.delete()
                    window.location.href = json_data.eappLink
                    return
                }

                throw new Error(json_data.message)

            } catch (error) {
                console.error('lgaQuoteCard->gotoEapp->error',error)
                this.error_dialogue = true
                this.eApp_dialog = false
                this.$store.commit('updateEnteringEApp', false)
            }
        },
    },
}
</script>


<style lang="scss" scoped>
$text--secondary: #9B9B9B;

.amount {
    font-weight: 800;
}

.get-started {
    color: #fff !important;
    font-family: Montserrat, SemiBold;
    font-weight: 600;
    font-size: 0.8rem;

    @media only screen and (max-width: 486px) {
        & {
            font-size: 0.7rem !important;
            img {
                width: 12px;
            }
        }
    }
}

.premium {
    text-align: left;
    font: normal normal 800 20px/34px Montserrat;
    letter-spacing: 0px;
    color: #46C3B2;
}

.main-frequency {
    text-align: left;
    font: normal normal bold 15px/34px Montserrat;
    letter-spacing: 0px;
    color: #46C3B2;
}

.secondary-premium {
    text-align: left;
    font: normal normal normal 12px/34px Montserrat;
    letter-spacing: 0px;
    color: #666666;
}
</style>